import React, { createContext, useContext, useState, useEffect } from 'react';
import { siteSettingsApi } from '../services/api';

export const DEFAULT_CONTACT_EMAIL = 'Info@zealmovers.com';
export const DEFAULT_CONTACT_PHONE = '(604) 213-6855';

export function telHref(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return 'tel:';
  if (digits.length === 10) return `tel:+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `tel:+${digits}`;
  return `tel:${digits}`;
}

const SiteSettingsContext = createContext({
  contactEmail: DEFAULT_CONTACT_EMAIL,
  contactPhone: DEFAULT_CONTACT_PHONE,
});

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState({ contact_email: '', contact_phone: '' });

  useEffect(() => {
    siteSettingsApi.get().then((data) => {
      setSettings({
        contact_email: data?.contact_email ?? '',
        contact_phone: data?.contact_phone ?? '',
      });
    }).catch(() => {});
  }, []);

  return (
    <SiteSettingsContext.Provider
      value={{
        contactEmail: settings.contact_email || DEFAULT_CONTACT_EMAIL,
        contactPhone: settings.contact_phone || DEFAULT_CONTACT_PHONE,
      }}
    >
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}
